export const onlyDigits = (value: string): string => {
  let digits = value.replace(',', '.').replace(/[^.\d]+/g, '')

  if (digits==='.') return '0.'

  if (digits && (digits.match(/\./g)?.length || 0) > 1) digits = digits.substr(0, digits.lastIndexOf('.'))

  if (!digits || /^\d+\.$|0$/.test(digits)) return digits || ''

  return Number(digits).toString()
}
